import { Button, ButtonProps } from '@mui/material';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { useTranslation } from 'react-i18next';

type SttButtonTicketProps = {
    caption?: string;
    block?: boolean;
    onClick: () => void;
} & ButtonProps;

/**
 * Ticket button
 */
export function SttButtonTicket({
    caption,
    block,
    onClick,
    ...rest
}: SttButtonTicketProps) {
    const { t } = useTranslation();

    return (
        <Button
            {...rest}
            variant="contained"
            color="primary"
            fullWidth={block}
            startIcon={<ConfirmationNumberIcon />}
            onClick={onClick}
        >
            {caption || t('Ticket')}
        </Button>
    );
}
